var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorshipSegment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3080_2218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0911 17.182L24 14.9999V23.9999H29.25C29.6644 23.9999 30 23.6643 30 23.2499V18.5606C30 18.2671 29.9139 17.98 29.7523 17.7349C29.5908 17.4899 29.3609 17.2976 29.0911 17.182ZM0 18.5606V23.2499C0 23.6643 0.335625 23.9999 0.75 23.9999H6V14.9999L0.908906 17.182C0.639144 17.2976 0.409242 17.4899 0.247683 17.7349C0.0861234 17.98 6.20628e-06 18.2671 0 18.5606H0ZM21.7716 11.5631L19.5 10.1999V4.81072C19.5 4.41276 19.342 4.03166 19.0603 3.74994L15.5302 0.219788C15.2372 -0.0731811 14.7623 -0.0731811 14.4698 0.219788L10.9397 3.74994C10.6584 4.03119 10.5 4.41276 10.5 4.81072V10.1999L8.22844 11.5631C8.00628 11.6963 7.82242 11.8848 7.69476 12.1102C7.5671 12.3356 7.5 12.5903 7.5 12.8493V23.9999H12V19.4999C12 17.8429 13.3434 16.4999 15 16.4999C16.6566 16.4999 18 17.8429 18 19.4999V23.9999H22.5V12.8493C22.5 12.3224 22.2234 11.834 21.7716 11.5631Z",
    fill: "#D2232A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3080_2218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorshipSegment);
export default __webpack_public_path__ + "static/media/worship-segment.592fb852807f08232ca2b4de5b46c037.svg";
export { ForwardRef as ReactComponent };